import { RouteRecordRaw } from 'vue-router';
import { StudentRouteName } from '../constants/routesName';
import { UserRole, ROUTE_CATEGORY } from '../types';

const AbsencesPage = () => import('@/features/absences/views/AbsencesPage.vue');
const AgendaView = () => import('@/features/agenda/views/AgendaView.vue');
const AroundTheWorldMap = () => import('@/features/around-the-world/views/AroundTheWorldMap.vue');
const ChatView = () => import('@/features/chat/views/ChatView.vue');
const HomePageStudent = () => import('@/features/homepage/views/HomePageStudent.vue');
const LiaisonDocumentDashboard = () =>
  import('@/features/liaison-document/liaisonDocumentDashboard/LiaisonDocumentDashboard.vue');
const LiaisonDocumentForm = () =>
  import('@/features/liaison-document/liaisonDocumentForm/views/LiaisonDocumentForm.vue');
const NewsPage = () => import('@/features/news/views/NewsPage.vue');
const NewsDetailPage = () => import('@/features/news/views/NewsDetailPage.vue');
const NotesPage = () => import('@/features/notes/views/NotesPage.vue');
const PagesMetiersPage = () => import('@/features/pages-metiers/views/PagesMetiers.vue');
const PartnershipUniversitiesMap = () =>
  import('@/features/partnership-universities/views/PartnershipUniversitiesMap.vue');
const ShopPage = () => import('@/features/shop/views/Shop.vue');

/**
 * Routes dédiées aux étudiants
 */
export const studentRoutes: RouteRecordRaw[] = [
  {
    path: '/student-home',
    name: StudentRouteName.StudentHome,
    component: HomePageStudent,
    meta: {
      requiresRole: UserRole.STUDENT,
      title: 'routes.studentHome',
      icon: 'home-outline',
      category: ROUTE_CATEGORY.STUDENT,
    },
  },

  {
    path: '/agenda',
    name: StudentRouteName.Agenda,
    component: AgendaView,
    meta: {
      requiresRole: UserRole.STUDENT,
      title: 'routes.agenda',
      icon: 'calendar-outline',
      category: ROUTE_CATEGORY.STUDENT,
    },
  },
  {
    path: '/around-the-world',
    name: StudentRouteName.AroundTheWorld,
    component: AroundTheWorldMap,
    meta: {
      requiresRole: UserRole.STUDENT,
      title: 'routes.aroundTheWorld',
      icon: 'globe-outline',
      category: ROUTE_CATEGORY.STUDENT,
    },
  },
  {
    path: '/chat',
    name: StudentRouteName.Chat,
    component: ChatView,
    meta: {
      requiresRole: UserRole.STUDENT,
      title: 'routes.chat',
      icon: 'chatbubble-ellipses-outline',
      category: ROUTE_CATEGORY.STUDENT,
    },
  },
  {
    path: '/news',
    name: StudentRouteName.News,
    component: NewsPage,
    meta: {
      requiresRole: UserRole.STUDENT,
      title: 'routes.news',
      icon: 'newspaper-outline',
      category: ROUTE_CATEGORY.STUDENT,
    },
  },
  {
    path: '/news/:id',
    name: StudentRouteName.NewsDetail,
    component: NewsDetailPage,
    meta: {
      requiresRole: UserRole.STUDENT,
      title: 'routes.newsDetail',
      hideInMenu: true,
      category: ROUTE_CATEGORY.STUDENT,
    },
  },
  {
    path: '/partnership-universities',
    name: StudentRouteName.PartnershipUniversities,
    component: PartnershipUniversitiesMap,
    meta: {
      requiresRole: UserRole.STUDENT, // Temporarily disabled for testing
      title: 'routes.partnershipUniversities',
      icon: 'shield-outline',
      category: ROUTE_CATEGORY.STUDENT,
    },
  },
  {
    path: '/notes',
    name: StudentRouteName.Notes,
    component: NotesPage,
    meta: {
      requiresRole: UserRole.STUDENT,
      title: 'routes.notes',
      icon: 'school-outline',
      category: ROUTE_CATEGORY.STUDENT,
    },
  },
  {
    path: '/business/:id',
    name: StudentRouteName.Business,
    component: PagesMetiersPage,
    meta: {
      title: 'routes.business',
      requiresAuth: true,
      category: ROUTE_CATEGORY.COMMON,
      hideInMenu: true,
    },
  },
  // Chatbot route - Temporarily disabled (backend not ready)
  // {
  //   path: '/chatbot',
  //   name: 'Chatbot',
  //   component: () => import('@/features/chatbot/views/ChatbotView.vue'),
  //   meta: {
  //     requiresRole: UserRole.STUDENT,
  //     title: 'routes.chatbot',
  //     icon: 'chatbubble-outline',
  //     category: 'Student',
  //   },
  // },
  {
    path: '/shop',
    name: StudentRouteName.Shop,
    component: ShopPage,
    meta: {
      requiresRole: UserRole.STUDENT,
      title: 'routes.shop',
      icon: 'storefront',
      category: ROUTE_CATEGORY.STUDENT,
    },
  },
  {
    path: '/absences',
    name: StudentRouteName.Absences,
    component: AbsencesPage,
    meta: {
      requiresRole: UserRole.STUDENT,
      title: 'routes.absences',
      icon: 'time-outline',
      category: ROUTE_CATEGORY.STUDENT,
    },
  },
  {
    path: '/stage-alternance',
    name: StudentRouteName.StageAlternance,
    component: LiaisonDocumentDashboard,
    meta: {
      title: 'routes.stageAlternance',
      requiresAuth: true,
      category: ROUTE_CATEGORY.STUDENT,
      hideInMenu: true,
    },
  },
  {
    path: '/stage-alternance/form',
    name: StudentRouteName.StageAlternanceForm,
    component: LiaisonDocumentForm,
    meta: {
      title: 'routes.stageAlternanceForm',
      requiresAuth: true,
      category: ROUTE_CATEGORY.STUDENT,
      hideInMenu: true,
    },
  },
];
